<template>
  <nav class="energy-domain-nav" aria-label="源网荷储模块导航">
    <button
      v-for="item in items"
      :key="item.key"
      type="button"
      :class="[item.key, { active: activeDomain === item.key }]"
      @click="navigate(item.key)"
    >
      <span>{{ item.name }}</span>
      <em>{{ item.en }}</em>
    </button>
  </nav>
</template>

<script>
import { DOMAIN_NAV, DOMAIN_ROUTES } from "../data/demoData";

export default {
  name: "EnergyDomainNav",
  props: {
    activeDomain: { type: String, default: "source" },
  },
  data() {
    return { items: DOMAIN_NAV };
  },
  methods: {
    navigate(domain) {
      const target = DOMAIN_ROUTES[domain];
      if (target && this.$route.path !== target) this.$router.push(target);
    },
  },
};
</script>

<style scoped>
.energy-domain-nav {
  position: absolute;
  z-index: 80;
  top: 76px;
  left: 50%;
  width: 596px;
  height: 38px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  transform: translateX(-50%);
}
.energy-domain-nav::before {
  content: "";
  position: absolute;
  z-index: -1;
  inset: 8px -56px -7px;
  background: radial-gradient(ellipse, rgba(23, 101, 190, .38), transparent 70%);
  pointer-events: none;
}
.energy-domain-nav button {
  position: relative;
  min-width: 0;
  border: 1px solid rgba(73, 153, 231, .34);
  clip-path: polygon(9px 0, calc(100% - 9px) 0, 100% 50%, calc(100% - 9px) 100%, 9px 100%, 0 50%);
  background: linear-gradient(180deg, rgba(12, 48, 101, .94), rgba(4, 25, 64, .92));
  color: #8db7de;
  cursor: pointer;
  box-shadow: inset 0 0 18px rgba(48, 125, 210, .1);
  transition: color .2s ease, border-color .2s ease, filter .2s ease;
}
.energy-domain-nav button::after {
  content: "";
  position: absolute;
  left: 24%;
  right: 24%;
  bottom: 1px;
  height: 1px;
  background: transparent;
}
.energy-domain-nav button:hover,
.energy-domain-nav button.active {
  color: #f1fbff;
  border-color: #42e7de;
  filter: drop-shadow(0 0 8px rgba(54, 227, 218, .28));
}
.energy-domain-nav button.active::after { background: #50f0e2; box-shadow: 0 0 8px #50f0e2; }
.energy-domain-nav button.grid.active { border-color: #54a7ff; }
.energy-domain-nav button.load.active { border-color: #f6cd29; }
.energy-domain-nav button.storage.active { border-color: #ff8b58; }
.energy-domain-nav span,
.energy-domain-nav em { display: block; line-height: 1; }
.energy-domain-nav span { font-size: 13px; font-weight: 700; letter-spacing: 1px; }
.energy-domain-nav em { margin-top: 4px; color: #4c769d; font-size: 7px; font-style: normal; letter-spacing: 2px; }
</style>
